/**
 * Adds trailing zeros
 *
 * @param {string} decimalPart Decimal part (e.g. "32")
 * @param {number} decimalPlaces Number of wanted decimal places (e.g. 4)
 * @returns {string} Formatted decimal part (e.g. "3200")
 */
export function formatDecimalPart(decimalPart, decimalPlaces) {
  return (decimalPart + '0'.repeat(decimalPlaces)).slice(0, decimalPlaces)
}

/**
 * Parses a decimal string to it's parts
 *
 * @param {string} decimal Decimal string like "987.543" or "-41.42"
 * @returns {{}|{decimalPart: string, wholePart: string, sign: string}} Decimal parts or empty object on error
 */
export function parseDecimal(decimal) {
  const [, sign, wholePart, , decimalPart] = ('' + decimal).match(/^(-)?(\d+)(\.(\d+))?$/) || []

  if (!wholePart) {
    return {}
  }

  return {
    sign: sign === undefined ? '' : sign,
    wholePart,
    decimalPart: decimalPart === undefined ? '' : decimalPart
  }
}
